
export class Constants {
    // Date Formats
    static readonly FacilityTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
    static readonly DateFormat = 'YYYY-MM-DD';
    static readonly NoDecimalRegex = /^\d+$/;

    static readonly AcuitySummary = 'AcuitySummary';
    static readonly AcuityTrends = 'AcuityTrendsReport';
    static readonly ClientImpersonation = 'ClientImpersonation';
    static readonly Imports ='Imports';
    static readonly CostCenter = 'CostCenter';
    static readonly CostCenterWorkflowUrl = '/workflow/cost-center';
    static readonly CreatePermissionAreaName = 'CreatePermissionAreas';
    static readonly DailyChurnReport = 'DailyChurnReport';
    static readonly DeletePermissionAreaName = 'DeletePermissionAreas';
    static readonly DirectionAscending = 'ASC';
    static readonly DirectionDescending = 'DESC';
    static readonly Facilities = 'Facilities';
    static readonly HuronAdminClientId = 'HuronAdminClientId';
    static readonly InpatientChurnRateReport = 'InpatientChurnRateReport';
    static readonly InpatientMeasureReport = 'InpatientMeasureReport';
    static readonly InpatientPerformanceReport = 'InpatientPerformanceReport';
    static readonly InpatientVarianceReport = 'InpatientVarianceReport';
    static readonly TotalUosVarianceReport = 'TotalUosVarianceReport';
    static readonly JobTitles = 'JobTitles';
    static readonly LandingPage = 'LandingPage';
    static readonly ManageableRoles = 'ManageableRoles';
    static readonly NurseSummary = 'NurseSummary';
    static readonly PerformanceReport = 'PerformanceReport';
    static readonly TotalUosPerformanceReport = 'TotalUosPerformanceReport';
    static readonly ReadPermissionAreaName = 'ReadPermissionAreas';
    static readonly RequestAreaName = 'RequestArea';
    static readonly ResetStaffingGridWarning = "Saving these changes will reset this cost center's staffing grid.";
    static readonly SelectCostCenter = 'SelectCostCenter';
    static readonly SelectShiftBlock = 'SelectShiftBlock';
    static readonly Measures = 'Measures';
    static readonly TotalUosMeasureReport = 'TotalUosMeasureReport';
    static readonly MeasureReport = 'MeasureReport';
    static readonly StaffingGrid = 'StaffingGrid';
    static readonly TokenName = 'Token';
    static readonly TotalUosSummary ='TotalUosSummary';
    static readonly TotalUosTrendsReport ='TotalUosTrendsReport';
    static readonly UpdatePermissionAreaName = 'UpdatePermissionAreas';
    static readonly Users = 'Users';
    static readonly VarianceReasons = 'VarianceReasons';
    static readonly VarianceReport = 'VarianceReport';
    static readonly Planner = 'Planner';
    static readonly UnitsOfService = 'UnitsOfService';
    static readonly Procedures = 'Procedures';
    static readonly ClientConfiguration = 'ClientConfiguration';
    static readonly ShiftLeaderWithReportAccess = 'Shift Leader';
    static readonly ShiftLeaderWithoutReportAccess = 'Shift Leader WithoutReportAccess';
    static readonly ExecutiveVariance = 'ExecutiveVarianceReport';
    static readonly CostCenterMapping = 'CostCenterMapping';
    static readonly JobTitleMapping = 'JobTitleMapping';
    static readonly GATrackingButton = 'button';
    static readonly GATrackingSubmit = 'submit';
    static readonly GAClickEvent = 'Click';
    static readonly GANavigateEvent = 'Navigate';
    static readonly GAEventCategoryIndex = 3;
    static readonly GAEventLabelIndex = 2;
    static readonly AddOnsNegativeValueWarning = 'Entering negative values will reduce the scheduled volume and target levels.';
    static readonly TimePayCodeMapping = 'TimePayCodeMapping';
    static readonly DebounceTime = 300;

    static readonly AdminPages: string[][] = [        
        [ Constants.ClientImpersonation, "/smt/admin/client-impersonation", "Client Impersonation" ],  
        [ Constants.ClientConfiguration, "/smt/admin/client-configuration", "Client Configuration" ],
        [ Constants.CostCenter, "/smt/staffing/cost-center", "Cost Center" ],
        [ Constants.Facilities, "/smt/admin/facility", "Facilities" ],
        [ Constants.JobTitles, "/smt/admin/job-title", "Job Titles" ],
        [ Constants.Procedures, "/smt/admin/procedure", "Procedures" ],
        [ Constants.Measures, "/smt/admin/measures", "Measures" ],
        [ Constants.Users, "/smt/admin/user", "Users" ],
        [ Constants.UnitsOfService, "/smt/admin/units-of-service", "Units of Service" ],
        [ Constants.VarianceReasons, "/smt/admin/variance-reason", "Variance Reasons" ]
    ];

    static readonly ImportPages: string[][] = [ 
      [ Constants.CostCenterMapping, "/smt/admin/cost-center-mapping", "Cost Center Mapping" ],
      [ Constants.JobTitleMapping, "/smt/admin/job-title-mapping", "Job Title Mapping" ],
      [ Constants.TimePayCodeMapping, "/smt/admin/time-pay-code-mapping", "Time Pay Code Mapping" ]
    ];

    static readonly WorkflowPages: string[][] = [
        [Constants.Planner, "/workflow/planner", "Enter Staffing Plan"],
        [Constants.SelectCostCenter, Constants.CostCenterWorkflowUrl, "Select Cost Center"],
        [Constants.SelectShiftBlock, "/workflow/shift-block", "Select Shift Block"]
    ]

    static readonly ReportsPages: string[][] = [
      [ Constants.ExecutiveVariance, "/smt/reports/executive-variance-report", "Executive Variance" ],
      [ Constants.NurseSummary, "/smt/reports/nurse-summary", "Nurse Summary" ],
      [ Constants.AcuitySummary, "/smt/reports/activity-summary", "Activity Summary" ],
      [ Constants.TotalUosSummary, "/smt/reports/total-uos-summary", "Total UOS Summary" ]
    ];
  
    static readonly AcuityReportsSubNavPages: string[][] = [
      [ Constants.AcuitySummary, "/smt/reports/activity-summary", "Activity Summary" ],
      [ Constants.PerformanceReport, "/smt/reports/performance-report", "Performance" ],
      [ Constants.AcuityTrends, "/smt/reports/activity-trends-report", "Activity Trends" ],
      [ Constants.MeasureReport, "/smt/reports/measures-report", "Measures" ],
      [ Constants.VarianceReport, "/smt/reports/variance-drilldown-report", "Reasons for Variance" ]
     
    ];
    
    static readonly InpatientReportsSubNavPages: string[][] = [
      [ Constants.NurseSummary, "/smt/reports/nurse-summary", "Nurse Summary" ],
      [ Constants.InpatientPerformanceReport, "/smt/reports/inpatient-performance-report", "Performance" ],
      [ Constants.InpatientChurnRateReport, "/smt/reports/inpatient-churn-rate", "Churn Rate" ],
      [ Constants.InpatientMeasureReport, "/smt/reports/inpatient-measures-report", "Measures" ],
      [ Constants.InpatientVarianceReport, "/smt/reports/inpatient-variance-drilldown-report", "Reasons for Variance" ]
      
    ];
    
    static readonly TotalUosReportsSubNavPages: string[][] = [
      [ Constants.TotalUosSummary, "/smt/reports/total-uos-summary", "Total UOS Summary" ],
      [ Constants.TotalUosPerformanceReport, "/smt/reports/total-uos-performance-report", "Performance" ],
      [ Constants.TotalUosTrendsReport, "/smt/reports/total-uos-trends-report", "Total UOS Trends" ],
      [ Constants.TotalUosMeasureReport, "/smt/reports/total-uos-measures-report", "Measures" ],
      [ Constants.TotalUosVarianceReport, "/smt/reports/total-uos-variance-drilldown-report", "Reasons for Variance" ]
    ];

    static readonly ExecutiveVarianceSubNavPages: string[][] = [
      [ Constants.ExecutiveVariance, "/smt/reports/executive-variance-report", "Executive Variance" ]
    ];

    static readonly Pages = Constants.AdminPages.concat(Constants.WorkflowPages)
                                                .concat(Constants.ReportsPages)
                                                .concat(Constants.ImportPages)
                                                .concat(Constants.AcuityReportsSubNavPages)
                                                .concat(Constants.InpatientReportsSubNavPages)
                                                .concat(Constants.TotalUosReportsSubNavPages);
    }
